module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHJJREFUeNpifCuvwkAKYGIgEQygBmYtTZ5Z05lkpInSAFTNt2IJm5sLq4U5YQ0Q1Yx8fD/XrAMiAhqAboCr/lpSTgNP/3vy9FNEzP9Pn9hDgrh7Oomy4e+163A9QESUkyB6fu3a8/vESTQpxmGQlgACDACdOi5LQkNt/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/left3.png
// module id = 617
// module chunks = 1 6